import React from 'react';
import './ConfirmDeleteDialog.css';

// Generic destructive-action confirmation. Defaults to the project-delete
// copy so existing ProjectView call sites keep working without changes;
// other call sites (e.g. AccountSettingsPage) can pass title/message/
// confirmLabel to customize the dialog.
const ConfirmDeleteDialog = ({
  onConfirm,
  onCancel,
  title = 'Are you sure?',
  message = 'This action cannot be undone. This will permanently delete the project.',
  confirmLabel = 'Yes, Delete',
}) => {
  return (
    <div className="dialog-overlay">
      <div className="dialog-content">
        <h3>{title}</h3>
        <p>{message}</p>
        <div className="dialog-buttons">
          <button onClick={onCancel} className="btn-secondary">Cancel</button>
          <button onClick={onConfirm} className="btn-red">{confirmLabel}</button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmDeleteDialog;
